import React from 'react';
import PropTypes from 'prop-types';

import BasicLabel from '../../../../components/BasicLabel';

export default function ArticulationAgreements({ getUrls, articulationAgreements }) {
  return (
    articulationAgreements.length &&
    articulationAgreements.map(({ hiid, name, state }) => {
      const urls = getUrls({ hiid, name, state });

      if (hiid) {
        return (
          <BasicLabel size="tiny" icon="circle thin" key={name}>
            <a href={urls.collegeProfilePath}>{name}</a>
          </BasicLabel>
        );
      }

      if (urls.collegeGroupPath) {
        return (
          <BasicLabel size="tiny" icon="circle thin" key={name}>
            <a href={urls.collegeGroupPath}>{name}</a>
          </BasicLabel>
        );
      }

      return (
        <BasicLabel size="tiny" icon="circle thin" key={name}>
          {name}
        </BasicLabel>
      );
    })
  );
}

ArticulationAgreements.propTypes = {
  getUrls: PropTypes.func,
  transferAdmissions: PropTypes.object,
};
